module.exports = __webpack_public_path__ + "static/szenario4_2-0a3dd325d1b0a26ae8fd1274d9e12d45.png";